//

import S from './styles';

const ImageEntityWrapper = ({ children }) => <S.Wrapper>{children}</S.Wrapper>;

export default ImageEntityWrapper;
